/**
 * <wild-hero>: the WILD homepage hero.
 *
 * - The water-caustic light and pointer ripples come from <wild-water> (assets/wild-water.js).
 * - Reveals the headline once fonts are ready, and eases the content away on scroll.
 *
 * Reduced motion gets a single still frame. Without WebGL the CSS gradient on the section shows.
 */
import { prefersReducedMotion, clamp01, whenFontsReady, onScroll } from '@wild/utils';
import { WildWater } from '@wild/water';

class WildHero extends WildWater {
  connectedCallback() {
    super.connectedCallback();
    this.content = this.querySelector('.wild-hero__content');
    this.revealText();
    if (!prefersReducedMotion()) this.bindScroll();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeScroll?.();
  }

  // Wait for the brand fonts (max 1.2s) so the headline animates in Monarch Nova, not a fallback.
  revealText() {
    whenFontsReady(1200).then(() => requestAnimationFrame(() => this.classList.add('is-ready')));
  }

  // Content drifts up and fades while the water light dims.
  bindScroll() {
    this.unsubscribeScroll = onScroll(() => {
      const rect = this.getBoundingClientRect();
      const progress = clamp01(-rect.top / rect.height);
      this.content.style.transform = `translateY(${progress * 90}px)`;
      this.content.style.opacity = String(1 - progress * 1.3);
      this.style.setProperty('--wh-canvas-opacity', String(1 - progress * 0.6));
    });
  }
}

if (!customElements.get('wild-hero')) customElements.define('wild-hero', WildHero);
